// src/pages/Gallery.tsx
import React from 'react';
import { motion } from 'framer-motion';
import Gallery from '../components/sections/Gallery';
import { staggerContainer, fadeInUp } from '../utils/animations';

const GalleryPage: React.FC = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-mauve-50 to-white pt-24 pb-16">
        <motion.div
          initial="initial"
          animate="animate"
          variants={staggerContainer}
          className="container-custom text-center"
        >
          <motion.h1 
            variants={fadeInUp}
            className="text-5xl font-bold text-mauve-900 mb-6"
          >
            Nail Art Gallery
          </motion.h1>
          <motion.p 
            variants={fadeInUp}
            className="text-xl text-mauve-700 max-w-3xl mx-auto mb-8"
          >
            Discover our collection of traditional Adinkra designs, modern Afro-chic styles, 
            and professional nail treatments created in Accra
          </motion.p>
          <motion.div variants={fadeInUp} className="flex justify-center gap-4">
            <span className="px-4 py-2 bg-mauve-100 text-mauve-700 rounded-full">
              Adinkra Symbols
            </span>
            <span className="px-4 py-2 bg-mauve-100 text-mauve-700 rounded-full">
              Kente Patterns
            </span>
            <span className="px-4 py-2 bg-mauve-100 text-mauve-700 rounded-full">
              Modern Designs
            </span>
            <span className="px-4 py-2 bg-mauve-100 text-mauve-700 rounded-full">
              Bridal Nails
            </span>
          </motion.div>
        </motion.div>
      </section>

      {/* Gallery Component */}
      <Gallery />
    </motion.main>
  );
};

export default GalleryPage;